var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFillCheck = function SvgFillCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M13.5 2.5C12 1 9.9.3 8 .3S4 1 2.5 2.5c-3 3-3 7.9 0 10.9C4 15 6.1 15.8 8 15.8s4-.8 5.5-2.2c3-3.2 3-8 0-11.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m7.3 11.5-.4-.4-3-3.2.8-.7L7.3 10l4.9-4.5.8.8z"
  })));
};
export default SvgFillCheck;